import { Select, SelectProps } from 'antd';
import React from 'react';

interface CustomSelectProps extends SelectProps<any, any> {
  title: string;
  data?: Array<any>;
  idKey: string;
  onChangeValue: (value: any, option: any, idKey: string) => void;
  classNameLabel?: string;
  isRequired?: boolean;
}

const CustomSelect = (props: CustomSelectProps) => {
  const { title, data, onChangeValue, idKey, classNameLabel, isRequired, ...selectProps } = props;

  return (
    <>
      <div className={`min-w-[150px] font-bold text-default text-black sm:text-end ${classNameLabel}`}>
        <label htmlFor={idKey} className=" cursor-pointer">
          {title} {isRequired && <span className="text-red-500">*</span>}
        </label>
      </div>
      <Select
        {...selectProps}
        className={
          `col-span-2 text-gray-700 !text-default [&_span]:!text-default hover:ring-0 hover:outline-none hover:border-border_input !rounded-none border-border_input sm:!ml-5 focus-visible:outline-none` +
          selectProps.className
        }
        options={data}
        id={idKey}
        showArrow
        style={{ borderRadius: '10px' }}
        onChange={(value, option) => onChangeValue(value, option, idKey)}
      />
    </>
  );
};

export default CustomSelect;
